import React from "react";
import appService from "../../../services/app.service";
import { DetailsOverview } from "../base/DetailsOverview";
import { useTranslation } from "react-i18next";
import { NoDataAdminAlert } from "../../NoDataAdminAlert"

export const AdditionalInfoOverview: React.FunctionComponent<{
    isDataAdmin: boolean;
}> = (props) => {
    const { isDataAdmin } = props;
    const detailsRedirection = "/config/additionalinfo/details";
    const { t } = useTranslation();
    const title = t("client:headers:tabAdditionalInfos");

    if (isDataAdmin !== true) {
        return <NoDataAdminAlert />
    }

    return (
        <DetailsOverview detailsRedirection={detailsRedirection} getItems={appService.getAdditionalInfo} entityType="additionalinfo" title={title}></DetailsOverview>
    );
};